// extracted by mini-css-extract-plugin
module.exports = {"provider":"i_Zg","coach":"i_Zh","stack":"i_Zi","question":"i_Zj"};